import styles from '@shared/styles/components/StatusDot.module.css'

interface StatusDotProps {
    color: string
    className?: string
}

const StatusDot: React.FC<StatusDotProps> = ({ color, className }) => (
    <span
        className={['DSStatusDot', styles.dot, className].filter(Boolean).join(' ')}
        style={{ backgroundColor: color }}
        aria-hidden="true"
    />
)

export default StatusDot
